// Delete a goal alert rule (DELETE /goals/:goalId/alerts/:alertId).
const action = "DISCOVERY_DELETE_ALERT";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { goalId, alertId }
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
